import { environment } from '@environments/environment';

export class PurchaseVehicle {
	registration: string;
	make: string;
	model: string;
	edition: string;
	brand_logo_url: string;
	price: number;
	mileage: number;
	doors: number;
	fuel_type: string;
	engine_l: number;
	year: number;
	gearbox: string;
	images: string[] = [];
	vat_qualifying: boolean;
	body: string;
	sale_type: 'car' | 'van' | 'bike';
	battery_range: number;
	battery_fast_charge_time: number;

	[propName: string]: any;

	constructor(purchase_vehicle: PurchaseVehicle) {

		purchase_vehicle.year = this.getRegisteredYear(purchase_vehicle.registered);
		purchase_vehicle.images = this.getImages(purchase_vehicle.images);

		Object.assign(this, purchase_vehicle);
	}

	getRegisteredYear(registered: { date: string }): number {
		return new Date(registered.date).getFullYear() || null;
	}

	getImages(images: string[]): string[] {
		if (!images.length) {
			return ['/assets/img/vehicle-placeholder.png'];
		}

		return images.map((image_url: string) => {
			return environment.vehicle_image_url + image_url;
		});

	}
}
